export { default as Skeleton } from "./skeleton";
